
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import PartnersHero from './components/PartnersHero';
import PartnersGrid from './components/PartnersGrid';
import PartnershipBenefits from './components/PartnershipBenefits';
import BecomePartner from './components/BecomePartner';

export default function Partners() {
  useEffect(() => {
    // SEO Meta Tags
    document.title = 'Partenaires - Cobra Sécurité | Réseau Partenaires Tunisie';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Découvrez nos partenaires de confiance et rejoignez le réseau Cobra Sécurité. Partenariats stratégiques avec les leaders de la sécurité en Tunisie.');
    }
    
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/partners`);
    }

    // Schema.org JSON-LD
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Partenaires Cobra Sécurité",
      "description": "Réseau de partenaires et opportunités de collaboration",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/partners`,
      "mainEntity": {
        "@type": "Organization",
        "name": "Cobra Sécurité",
        "description": "Réseau de partenaires en solutions de sécurité",
        "partner": [
          {
            "@type": "Organization",
            "name": "Hikvision",
            "description": "Leader mondial en solutions de vidéosurveillance"
          },
          {
            "@type": "Organization",
            "name": "Dahua Technology",
            "description": "Fabricant de systèmes de sécurité innovants"
          },
          {
            "@type": "Organization",
            "name": "Axis Communications",
            "description": "Pionnier de la vidéosurveillance IP"
          }
        ]
      },
      "offers": {
        "@type": "Offer",
        "name": "Programme Partenaire",
        "description": "Rejoignez notre réseau de partenaires certifiés",
        "category": "Partenariat Commercial"
      }
    });
    
    document.head.appendChild(schemaScript);

    return () => {
      document.head.removeChild(schemaScript);
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <h1 style={{ position: 'absolute', left: '-9999px' }}>Partenaires Cobra Sécurité</h1>
        <PartnersHero />
        <PartnersGrid />
        <PartnershipBenefits />
        <BecomePartner />
      </main>
      <Footer />
    </div>
  );
}
